import { Component, OnInit, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { ImageCropperComponent, CropperSettings, ImageCropperModule } from 'ngx-img-cropper';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

/*Services*/
import { AuthenticationService } from '@services/laravel/authentication.service';
import { ValidateRequired } from '@shared/validators/required.validator';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    standalone: true,
    selector: 'ntm-pick-image',
    templateUrl: './pick-image.component.html',
    styleUrls: ['./pick-image.component.css'],
    imports: [CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, ImageCropperModule, MatButton]
})
export class PickImageComponent implements OnInit {
  @Output()
  change: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('cropper', {static: false})
cropper:ImageCropperComponent;

  validForm: any = false;
  image_data: any;
  image_data_preview: any;
  default_image: any = {"src": "data:image/jpeg;base64,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"};
  cropperSettings: CropperSettings;

  isLoading = true;
  msg;
  pickImageForm: UntypedFormGroup;
  constructor(
    private authentication: AuthenticationService,
    public dialogRef: MatDialogRef<PickImageComponent>,
    private router: Router,
    public mdsnackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 100;
    this.cropperSettings.height = 100;
    this.cropperSettings.croppedWidth = 400;
    this.cropperSettings.croppedHeight = 400;
    this.cropperSettings.canvasWidth = 350;
    this.cropperSettings.canvasHeight = 250;
    this.cropperSettings.noFileInput = true;
 
    this.image_data = {};
    this.image_data_preview = this.default_image;
  }

  ngOnInit() {
    var default_image:any = new Image();
    var that = this;
    default_image.src = this.image_data.image;
    
    this.pickImageForm = new UntypedFormGroup({
      'avatar_path': new UntypedFormControl(null, [ValidateRequired]),
    });
  }

  close = () => {
    this.dialogRef.close();
  }

  onSave = () => {
    this.dialogRef.close(this.image_data);
  }

  fileChangeListener($event) {
    var image:any = new Image();
    var file:File = $event.target.files[0];
    var myReader:FileReader = new FileReader();
    var that = this;
    myReader.onloadend = function (loadEvent:any) {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
    };
    
    this.image_data = $event.target.files[0];
    this.image_data_preview = image;
    this.validForm = true;
 
    myReader.readAsDataURL(file);
  }
}
